<script lang="ts" setup>
import { computed } from 'vue';
import { VTooltip } from 'vuetify/components';
import { useConfigHelper } from '@ilteducation/config';
import { useGradeHelpers } from '@ilteducation/grade-helpers-vue';
import { useLocale } from '../composables/useLocale';

const props = withDefaults(
  defineProps<{
    name: string;
    yearsInSchool?: number | null;
    size?: 'small' | 'default';
  }>(),
  { yearsInSchool: null, size: 'default' },
);

const { t } = useLocale();
const { convertYearsInSchoolToGrade } = useGradeHelpers(useConfigHelper().getRealm());

const grade = computed(() =>
  props.yearsInSchool === null || props.yearsInSchool === undefined
    ? null
    : (convertYearsInSchoolToGrade(props.yearsInSchool) ?? null),
);
</script>

<template>
  <span class="group-label d-inline-flex align-center flex-nowrap">
    <span class="text-truncate">{{ name }}</span>
    <span
      v-if="grade"
      class="group-label__grade"
      :class="{ 'group-label__grade--small': size === 'small' }"
      role="img"
      :aria-label="`${t('lcp.grade')}: ${grade}`"
    >
      {{ grade }}
      <VTooltip activator="parent" location="top" :text="t('lcp.grade')" />
    </span>
  </span>
</template>

<style lang="scss" scoped>
.group-label__grade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 8px;
  margin-left: 8px;
  border: 1px solid rgb(var(--v-theme-outline-variant));
  border-radius: 8px;
  // A step up in tone from the chips the label sits inside, which are surface-container-low.
  background-color: rgb(var(--v-theme-surface-container-high));
  font-size: 0.875rem;
  line-height: 1;
  white-space: nowrap;
}

.group-label__grade--small {
  height: 22px;
  padding: 0 6px;
  margin-left: 6px;
  border-radius: 6px;
  font-size: 0.75rem;
}
</style>
